/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tourhelp_LabelInputs */

const en_tourhelp_label = /** @type {(inputs: Tourhelp_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help and tours`)
};

/** @type {(inputs: Tourhelp_LabelInputs) => LocalizedString} */
const ar_tourhelp_label = en_tourhelp_label;

/** @type {(inputs: Tourhelp_LabelInputs) => LocalizedString} */
const he_tourhelp_label = en_tourhelp_label;

/** @type {(inputs: Tourhelp_LabelInputs) => LocalizedString} */
const ur_tourhelp_label = en_tourhelp_label;

/** @type {(inputs: Tourhelp_LabelInputs) => LocalizedString} */
const es_tourhelp_label = en_tourhelp_label;

/** @type {(inputs: Tourhelp_LabelInputs) => LocalizedString} */
const fr_tourhelp_label = en_tourhelp_label;

/** @type {(inputs: Tourhelp_LabelInputs) => LocalizedString} */
const de_tourhelp_label = en_tourhelp_label;

/** @type {(inputs: Tourhelp_LabelInputs) => LocalizedString} */
const pt_tourhelp_label = en_tourhelp_label;

/** @type {(inputs: Tourhelp_LabelInputs) => LocalizedString} */
const hi_tourhelp_label = en_tourhelp_label;

/** @type {(inputs: Tourhelp_LabelInputs) => LocalizedString} */
const bn_tourhelp_label = en_tourhelp_label;

/**
* | output |
* | --- |
* | "Help and tours" |
*
* @param {Tourhelp_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const tourhelp_label = /** @type {((inputs?: Tourhelp_LabelInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tourhelp_LabelInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_tourhelp_label(inputs)
	if (locale === "he") return he_tourhelp_label(inputs)
	if (locale === "ur") return ur_tourhelp_label(inputs)
	if (locale === "es") return es_tourhelp_label(inputs)
	if (locale === "fr") return fr_tourhelp_label(inputs)
	if (locale === "de") return de_tourhelp_label(inputs)
	if (locale === "pt") return pt_tourhelp_label(inputs)
	if (locale === "hi") return hi_tourhelp_label(inputs)
	if (locale === "bn") return bn_tourhelp_label(inputs)
	return /** @type {LocalizedString} */ ("Help and tours")
});